module.exports = __webpack_public_path__ + "static/media/46513803_333786177451395_717430310626656256_n.4744f916.jpg";